import { useLoaderData } from "react-router-dom";
import { Ticket } from "../../../types/Ticket";
import BookingFlow from "../../booking/BookingFlow";
import { Event, EventTicket, SubmitEventTicketRequest } from "../EventTypes";
import EventTicketForm from "../form/EventTicketForm";

export default function EventBookingFlow() {

    const event = useLoaderData() as Event;

    return <>
        {
            event ?
                <BookingFlow
                    ticket={
                        {
                            handler: (onTicketConfigurationCompleted) =>
                                <EventTicketForm
                                    onComplete={
                                        (amount: number) =>
                                            onTicketConfigurationCompleted(
                                                {
                                                    eventId: event.reference,
                                                    type: 'Event',
                                                    amount: amount
                                                } as EventTicket
                                            )
                                    }
                                    event={event}
                                />,
                            submitCall: {
                                path: 'ticket/event',
                                mapper: (ticket: Ticket) => {
                                    let eventTicket = ticket as EventTicket;
                                    return {
                                        eventId: eventTicket.eventId,
                                        amount: eventTicket.amount
                                    } as SubmitEventTicketRequest;
                                }
                            }
                        }
                    }
                    customer={
                        {
                            types: ['PERSON']
                        }
                    }
                />
                : <>Leider konnten wir das Event nicht finden</>
        }
    </>
}